import api from '../httpClient/httpClient';

export async function fetchData<T>(url: string): Promise<T> {
  const hash = sessionStorage.getItem('access_token');
  const config = {
    headers: {
      'Content-type': 'application/json',
      Authorization: hash,
    },
  };
  const response = await api.get<T>(url, config);
  return response as T;
}

export async function put<T>(url: string, data: any): Promise<T> {
  const hash = sessionStorage.getItem('access_token');
  const config = {
    headers: {
      'Content-type': 'application/json',
      Authorization: hash,
    },
  };
  const response = await api.put<T>(url, data, config);
  return response as T;
}

export async function post<T>(url: string, data: any): Promise<T> {
  const hash = sessionStorage.getItem('access_token');
  const config = {
    headers: {
      'Content-type': 'application/json',
      Authorization: hash,
    },
  };
  const response = await api.post<T>(url, data, config);
  return response as T;
}

export async function deleteData<T>(url: string): Promise<T> {
  const hash = sessionStorage.getItem('access_token');
  const config = {
    headers: {
      'Content-type': 'application/json',
      Authorization: hash,
    },
  };
  const response = await api.delete<T>(url, config);
  return response as T;
}

export async function uploadApi<T>(url: string, data: FormData, config:any): Promise<T> {
  const response = await api.post<T>(url, data, config);
  return response as T;
}
